// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/plus.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'plus',
  version: 'outline',
  paths: [
    {
      d: 'M12 4.5v15m7.5-7.5h-15',
    },
  ],
}
